import { AdminPageHeader } from "@admin-ui/components/composed/AdminPageHeader";
import { AdminLayout } from "@admin-ui/components/frames/AdminLayout";
import { Head } from "@inertiajs/react";
import { adminDestinationsPath } from "@travily/routes";
import type AdminDestinationsFactorsIndex from "@travily/types/pages/AdminDestinationsFactorsIndex";
import type { ReactNode } from "react";
import { useAdminLayoutAccount } from "@/hooks/admin/use-admin-layout-account";
import AdminPersistentLayout from "@/layouts/admin-persistent-layout";
import { IndexView } from "./index.view";

function AdminDestinationsFactorsIndexPage({ corpus_size, measured_share, factors }: AdminDestinationsFactorsIndex) {
  const account = useAdminLayoutAccount();

  return (
    <AdminLayout activeUrl={adminDestinationsPath()} account={account}>
      <Head title="Factor health - Admin" />

      <AdminPageHeader
        breadcrumbs={[{ label: "Destinations", href: adminDestinationsPath() }]}
        title="Factor health"
        subtitle="What fills each ranking factor, and how much of the corpus it can actually be scored on"
      />

      <div className="mx-auto flex w-full max-w-container flex-col gap-6 px-4 lg:gap-8 lg:px-8">
        <IndexView corpusSize={corpus_size} factors={factors} measuredShare={measured_share} />
      </div>
    </AdminLayout>
  );
}

AdminDestinationsFactorsIndexPage.layout = (page: ReactNode) => <AdminPersistentLayout>{page}</AdminPersistentLayout>;

export default AdminDestinationsFactorsIndexPage;
